import * as XLSX from 'xlsx';

function fitToColumn(arrayOfArray) {
  if (!Array.isArray(arrayOfArray)) return [];

  return arrayOfArray[0].map((_, i) => ({
    wch: Math.max(...arrayOfArray.map((a2) => (a2[i] ? a2[i].toString().length : 0)))
  }));
}

function jsonToXlsx({ name = '', headers = [], data = [], colsWidth = [] } = {}) {
  const dt = data || [];
  const dataRows = dt.map((item) => {
    return Object.values(item);
  });

  dataRows.unshift(headers);

  const ws = XLSX.utils.aoa_to_sheet(dataRows);

  if (colsWidth && colsWidth.length > 0) {
    ws['!cols'] = colsWidth;
  } else {
    ws['!cols'] = fitToColumn(dataRows);
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
  XLSX.writeFile(wb, `${name}.xlsx`);
}

export { jsonToXlsx };
